export default __webpack_public_path__ + "static/media/icon-settings.35581313.svg";